<template>
    <modal :show.sync=show modalClasses="property-unit-modal" :hide-footer="true">
        <div>
            <div v-if="!unit_by_levels || unit_by_levels.length === 0">No Units Found.</div>
            <div v-else>
                <div v-if="unitCategory(project_type) !== 'landed'">{{ project_type }}
                    <div class="table-select-unit">
                        <b-table-simple responsive bordered>
                            <b-tbody>
                                <b-tr v-for="(level, index) in filteredUnitByLevels" :key="index">
                                    <b-td v-if="level.length > 0">
                                        <h4>Level {{ level[0].floor_sort }}</h4>
                                    </b-td>
                                    <b-td v-for="(unit, index) in level" :key="index" 
                                        :style="{
                                            'color': 'white',
                                            'background': UNIT_COLOR[unit.available_status ],
                                        }"
                                    >
                                        <p class="font-weight-bold text-capitalize" :class="unit.available_status !== 'Not available' ? 'text-white' : 'text-muted'">{{ unit.available_status }}</p>
                                        <p class="font-weight-bold">RM {{ unit.unit_price | moneyFormatter }}</p>
                                        <span class="text-xs text-dark">{{ unit.unit_no }} | {{ unit.built_up }} sqft.</span>
                                    </b-td>
                                    <b-td v-for="index in maxColumns - level.length" :key="'empty-' + index"></b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </div>
                <div v-else>{{ project_type }}
                    <b-row>
                        <div class="table-select-unit">
                            <b-table-simple responsive bordered>
                                <b-tbody>
                                    <b-tr v-for="(chunk, chunkIndex) in chunkedLandedUnits" :key="chunkIndex">
                                        <b-td v-for="(unit, unitIndex) in chunk" :key="unitIndex"
                                            :style="{
                                                'color': 'white',
                                                'background': UNIT_COLOR[unit.available_status],
                                            }"
                                        >
                                            <p class="font-weight-bold text-capitalize" :class="unit.available_status !== 'Not available' ? 'text-white' : 'text-muted'">{{ unit.available_status }}</p>
                                            <p class="font-weight-bold">RM {{ unit.unit_price | moneyFormatter }}</p>
                                            <span class="text-xs text-dark">{{ unit.unit_no }} | {{ unit.built_up }} sqft.</span>
                                        </b-td>
                                        <!-- Fill the row with empty cells if the chunk has less than 8 units -->
                                        <b-td v-for="index in 8 - chunk.length" :key="'empty-' + index"></b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </div>
                    </b-row>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Image, Switch, Button } from 'element-ui'
import {UNIT_COLOR} from '@/assets/js/colors.js'

export default {
    props: ['show_browse_unit'],
    components: {
        Modal,
        [Image.name]: Image,
        [Switch.name]: Switch,
        [Button.name]: Button,
    },
    data() {
        return {
            unit_by_levels: [],
            project_type: '',
            UNIT_COLOR:UNIT_COLOR,
        }
    },
    computed: {
        show: {
            get() {
                return this.show_browse_unit
            },
            set(newVal) {
                this.$emit('update:show_browse_unit', newVal)
            },
        },
        filteredUnitByLevels() {
            // Filter out levels where level[0].floor_sort is null
            return this.unit_by_levels.filter(level => level.length > 0 && level[0].floor_sort !== null);
        },
        maxColumns() {
            return Math.max(...this.filteredUnitByLevels.map(arr => arr.length))
        },
         unitCategory() {
            const UNIT_TYPE_CATEGORY = {
                'Condominium': 'non-landed',
                'Service Apartment/ Residence': 'non-landed',
                'Service suites': 'non-landed',
                'Penthouse': 'non-landed',
                'Duplex': 'non-landed',
                'Flat': 'non-landed',
                'Apartment': 'non-landed',
                '1-sty terrace/link house': 'landed',
                '2-sty terrace/link house': 'landed',
                '3-sty terrace/link house': 'landed',
                '4-sty terrace/link house': 'landed',
                'Bungalow': 'landed',
                'Zero-lot bungalow': 'landed',
                'Mansion': 'landed',
                'Cluster Home': 'landed',
                'Semi- D': 'landed',
                'Villa': 'landed',
                'Shoplot/officelot': 'non-landed',
                'Townhouse': 'landed' // Typically considered landed
            };

            return type => UNIT_TYPE_CATEGORY[type] || 'unknown';
        },
        // FOR LANDED PROPERTY
        chunkedLandedUnits() {
            const chunkSize = 8;
            const chunks = [];
            const allUnits = [];
            if (this.unit_by_levels && this.unit_by_levels.length > 0) {
                this.unit_by_levels.forEach(levelArray => {
                    if (Array.isArray(levelArray) && levelArray.length > 0) {
                        levelArray.forEach(unit => {
                            if (unit) {
                                allUnits.push(unit);
                            }
                        });
                    }
                });
            }
            for (let i = 0; i < allUnits.length; i += chunkSize) {
                chunks.push(allUnits.slice(i, i + chunkSize));
            }
            return chunks;
        },
    },
    methods:{
        setUnits(unit_by_levels, project_type){
            if (Array.isArray(unit_by_levels)) {
                unit_by_levels.forEach((arr, idx) => {
                    console.log(`Array ${idx}:`, arr?.length, 'units');
                });
            }
            this.unit_by_levels = unit_by_levels
            this.project_type = project_type
        }
    }
}
</script>